
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    overflow: {
      type: Boolean,
      default: true,
    },
  },
}
